import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { CosignSupervisorsResponse } from "@/api/(requests)/permissionsTyped";

import { cosignKeys } from "../keyFactory";
import { getCosignSupervisors } from "../queryFunctions/getCosignSupervisors";

type UseCosignSupervisorsProps<TData = CosignSupervisorsResponse> = {
  enabled?: boolean;
  select?: (data: CosignSupervisorsResponse) => TData;
};

type CosignSupervisorsQueryOptions = UseQueryOptions<
  CosignSupervisorsResponse,
  unknown,
  CosignSupervisorsResponse,
  ReturnType<typeof cosignKeys.supervisors>
>;

export function optionFactory(enabled = true) {
  return {
    enabled,
    queryFn: getCosignSupervisors,
    queryKey: cosignKeys.supervisors(),
    staleTime: Infinity,
  } satisfies CosignSupervisorsQueryOptions;
}

export function useCosignSupervisors<TData = CosignSupervisorsResponse>({
  enabled = true,
  select,
}: UseCosignSupervisorsProps<TData> = {}) {
  return useQuery({ ...optionFactory(enabled), select });
}
